import AbstractFormulaNode from "./AbstractFormulaNode.js";

/**
 * Formula node representing the number of days in the current
 * fiscal year.
 */
export default class NumberOfDaysInFiscalYearNode extends AbstractFormulaNode {
	static getType() {
		return "NumberOfDaysInFiscalYear";
	}
}
